<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import NextInput from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const phoneNumber = ref('');
const otp = ref('');
const otpSent = ref(false);
const isSending = ref(false);
const isVerified = ref(false);

const sendOtp = async () => {
  if (!phoneNumber.value) return;
  isSending.value = true;
  await new Promise(resolve => {
    setTimeout(resolve, 800);
  });
  isSending.value = false;
  otpSent.value = true;
  useAlert(t('QUICK_SETUP.STEP_OTP.CODE_SENT'));
};

const verifyOtp = () => {
  if (otp.value.length !== 6) return;
  isVerified.value = true;
  useAlert(t('QUICK_SETUP.STEP_OTP.VERIFIED'));
};
</script>

<template>
  <div class="flex flex-col gap-5">
    <p class="text-sm text-n-slate-11">
      {{ t('QUICK_SETUP.STEP_OTP.DESCRIPTION') }}
    </p>
    <NextInput
      v-model="phoneNumber"
      type="text"
      :label="t('QUICK_SETUP.STEP_OTP.PHONE_LABEL')"
      :placeholder="t('QUICK_SETUP.STEP_OTP.PHONE_PLACEHOLDER')"
      :disabled="otpSent"
    />
    <NextButton
      v-if="!otpSent"
      variant="faded"
      color="blue"
      type="button"
      class="w-fit"
      :is-loading="isSending"
      :disabled="!phoneNumber"
      :label="t('QUICK_SETUP.STEP_OTP.SEND_CODE')"
      @click="sendOtp"
    />
    <template v-else>
      <NextInput
        v-model="otp"
        type="text"
        maxlength="6"
        :label="t('QUICK_SETUP.STEP_OTP.CODE_LABEL')"
        :placeholder="t('QUICK_SETUP.STEP_OTP.CODE_PLACEHOLDER')"
        :disabled="isVerified"
      />
      <NextButton
        v-if="!isVerified"
        variant="faded"
        color="teal"
        type="button"
        class="w-fit"
        :disabled="otp.length !== 6"
        :label="t('QUICK_SETUP.STEP_OTP.VERIFY_CODE')"
        @click="verifyOtp"
      />
      <p v-else class="flex items-center gap-1.5 text-sm text-n-teal-11">
        <span class="i-lucide-check-circle-2" />
        {{ t('QUICK_SETUP.STEP_OTP.VERIFIED') }}
      </p>
    </template>
  </div>
</template>
